import { FC, useState } from "react";
import CollapseCard from "../../../../components/collapseCard";
import DividerLine from "../../../../components/lineSplit";
import ResellerTaxFlagsSwitches from "../../../../components/resellerTaxFlagsSwitches";
import _t from "../../../../lang/translate";
import ResellerTaxReceiptActions from "./resellerTaxReceiptActions";
import ResellerTaxInvoiceActions from "./resellerTaxInvoiceActions";

const ResellerTaxActions: FC = () => {
  const [loading, setLoading] = useState<boolean>(false);

  return (
    <CollapseCard
      title={_t("customer", "checklist")}
      loading={loading}
    >
      <ResellerTaxFlagsSwitches setLoading={setLoading} />
      <DividerLine fluid />
      <ResellerTaxInvoiceActions setLoading={setLoading} />
      <DividerLine fluid />
      <ResellerTaxReceiptActions setLoading={setLoading} />
    </CollapseCard>
  );
};

export default ResellerTaxActions;
